
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conference-hall",
      function () {
        return require("private-next-pages/conference-hall.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conference-hall"])
      });
    }
  